import { memo } from 'react';

import Menu from '../../../Menu/Menu';
import { Root } from './ActionItem.styles';
import { ActionItemProps } from './ActionItem.types';

/**
 * The ActionItem renders action menu item in Select dropdown under the menu items
 */
export const ActionItem = memo<ActionItemProps>((props) => {
    const { actionItemProps } = props;

    return (
        <Root>
            <Menu.List items={[{ ...actionItemProps, active: true }]} />
        </Root>
    );
});

ActionItem.displayName = 'ActionItem';
